"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Credit = void 0;
var react_1 = __importDefault(require("react"));
var benefits_json_1 = __importDefault(require("./benefits.json"));
var extraInformation_json_1 = __importDefault(require("./extraInformation.json"));
var Credit_module_scss_1 = __importDefault(require("./Credit.module.scss"));
var BanksList_1 = require("../../components/banksList/BanksList");
var Benefits_1 = require("../../components/benefits/Benefits");
var CreditAbout_1 = require("../../components/creditAbout/CreditAbout");
var CreditOffersList_1 = require("../../components/creditOffersList/CreditOffersList");
var ExtraInformation_1 = require("../../components/extraInformation/ExtraInformation");
var FormCredit_1 = require("../../components/formCredit/FormCredit");
var selectors_1 = require("../../redux/selectors");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var useCreditForm_1 = require("../../hook/useCreditForm");
var CardAutoHorizontal_1 = require("../../components/cardAutoHorizontal/CardAutoHorizontal");
var selectors_2 = require("../../redux/selectors");
var convertToUrl_1 = require("../../helpers/convertToUrl");
var banksListSlice_1 = require("../../redux/slice/banksListSlice");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var Credit = function () {
    var _a = (0, useCreditForm_1.useCreditForm)(), register = _a.register, errors = _a.errors, onSubmit = _a.onSubmit, handleSubmit = _a.handleSubmit, sliderField = _a.sliderField, setValue = _a.setValue, payment = _a.payment;
    var dispatch = (0, react_redux_1.useDispatch)();
    var fromBanks = (0, react_router_dom_1.useLocation)().pathname.split('/')[2];
    var selectCar = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect;
    var bankList = (0, react_redux_1.useSelector)(selectors_2.banksListSelector).banksList;
    var getInitialLinks = function () {
        var initialLinks = [
            { name: 'Главная', url: '/' },
            { name: 'Автокредит', url: '/credit' },
        ];
        if (fromBanks && bankList.length > 0) {
            var targetBank = bankList.find(function (bank) { return (0, convertToUrl_1.convertToUrl)(bank.name) === fromBanks; });
            if (targetBank) {
                initialLinks.push({ name: targetBank.name, url: '' });
            }
        }
        return initialLinks;
    };
    var _b = react_1.default.useState(getInitialLinks()), links = _b[0], setLinks = _b[1];
    react_1.default.useEffect(function () {
        if (bankList.length > 0 && fromBanks) {
            var targetBank = bankList.find(function (bank) { return (0, convertToUrl_1.convertToUrl)(bank.name) === fromBanks; });
            dispatch((0, banksListSlice_1.setTargetBankId)((targetBank === null || targetBank === void 0 ? void 0 : targetBank.id) || null));
            setLinks(__spreadArray([
                { name: 'Главная', url: '/' },
                { name: 'Автокредит', url: '/credit' }
            ], (targetBank ? [{ name: targetBank.name, url: '' }] : []), true));
        }
    }, [bankList, fromBanks, dispatch]);
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "".concat(Credit_module_scss_1.default.credit, " page") },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: links }),
            react_1.default.createElement("h1", { className: "".concat(Credit_module_scss_1.default.credit__title, " page__title") }, "\u0410\u0432\u0442\u043E\u043A\u0440\u0435\u0434\u0438\u0442 \u043E\u0442 4.9%"),
            react_1.default.createElement(Benefits_1.Benefits, { benefits: benefits_json_1.default }),
            react_1.default.createElement("div", { className: Credit_module_scss_1.default.credit__content },
                react_1.default.createElement("aside", { className: Credit_module_scss_1.default.credit__column_form },
                    react_1.default.createElement(FormCredit_1.FormCredit, __assign({}, { register: register, errors: errors, onSubmit: onSubmit, handleSubmit: handleSubmit, sliderField: sliderField, setValue: setValue, payment: payment })),
                    react_1.default.createElement(ExtraInformation_1.ExtraInformation, __assign({}, extraInformation_json_1.default))),
                react_1.default.createElement("section", { className: Credit_module_scss_1.default.credit__column_about },
                    (selectCar === null || selectCar === void 0 ? void 0 : selectCar.brand) ? react_1.default.createElement(CardAutoHorizontal_1.CardAutoHorizontal, __assign({}, selectCar)) : null,
                    !fromBanks ? react_1.default.createElement(CreditOffersList_1.CreditOffersList, { payment: payment }) : null,
                    react_1.default.createElement(CreditAbout_1.CreditAbout, null))),
            react_1.default.createElement("div", { className: Credit_module_scss_1.default.credit__banks },
                react_1.default.createElement("h2", { className: Credit_module_scss_1.default.credit__banks_title }, "\u0411\u0430\u043D\u043A\u0438-\u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B"),
                react_1.default.createElement(BanksList_1.BanksList, null)))));
};
exports.Credit = Credit;
